module.exports = __webpack_public_path__ + "img/statistics_icon3.c663639f.png";